export enum YearlyPaymentType {
  None = "none",
  LumpSum = "lumpSum",
  ByFirstExamination = "byFirstExamination",
}
